export default (siteName) => [
    {
        path: '/:company_id/setPassword/:email/:token/:expireTime?',
        name: 'setPassword',
        component: () => import('../components/PasswordSetting.vue'),
        meta: {
            title: `設定密碼${siteName}`,
        },
    },
    {
        path: '/:company_id/resetPassword/:email/:token/:expireTime?',
        name: 'resetPassword',
        component: () => import('../components/PasswordSetting.vue'),
        meta: {
            title: `重設密碼${siteName}`,
        },
    },
    {
        path: '/forgotPassword',
        name: 'forgotPassword',
        component: () => import('../components/ForgotPasswordView.vue'),
        meta: {
            title: `密碼重設${siteName}`,
        },
    },
];
